module.exports = __webpack_public_path__ + "img/XZJH.999a16a2.svg";